// client/src/components/ListToolbar.jsx
// One consistent "search + sort" strip for every list in the back office.
//
//   <ListToolbar
//     search={{ value, onChange, placeholder }}          // optional
//     sort={{ value: { key, dir }, onChange, options }}  // optional
//     count={{ shown, total, noun }}                     // optional
//   >
//     {extra chips / buttons}                            // optional
//   </ListToolbar>
//
// Sort is a <select> of columns + a direction toggle. Picking a column keeps
// the direction; the arrow button flips it. Kept deliberately plain so it
// reads the same on the students roster and on a 6-card devices grid.

import { ArrowsUpDownIcon, MagnifyingGlassIcon } from './Icons.jsx';

export default function ListToolbar({ search, sort, count, children }) {
  return (
    <div className="card p-3 sm:p-4 flex flex-wrap items-center gap-2 sm:gap-3">
      {search && (
        <div className="relative flex-1 min-w-[12rem]">
          <MagnifyingGlassIcon className="w-4 h-4 text-ink-400 absolute top-1/2 -translate-y-1/2 start-3 pointer-events-none" />
          <input
            type="search"
            value={search.value}
            onChange={(e) => search.onChange(e.target.value)}
            placeholder={search.placeholder || 'חיפוש...'}
            aria-label={search.placeholder || 'חיפוש'}
            className="input ps-9 h-10"
          />
        </div>
      )}

      {sort && <SortControl value={sort.value} onChange={sort.onChange} options={sort.options} />}

      {children}

      {count && (
        <div className="text-sm text-ink-500 ms-auto whitespace-nowrap">
          {count.shown != null && count.shown !== count.total ? (
            <>
              <strong className="text-ink-700 num">{count.shown.toLocaleString('he-IL')}</strong>
              {' מתוך '}
              <strong className="text-ink-700 num">{count.total.toLocaleString('he-IL')}</strong>
            </>
          ) : (
            <>
              סה״כ <strong className="text-ink-700 num">{(count.total ?? 0).toLocaleString('he-IL')}</strong>
            </>
          )}
          {count.noun ? ` ${count.noun}` : ''}
        </div>
      )}
    </div>
  );
}

/** The sort <select> + direction toggle on its own, for tabs with a custom toolbar. */
export function SortControl({ value, onChange, options }) {
  return (
    <div className="flex items-center gap-1">
      <label className="text-xs font-semibold text-ink-500 whitespace-nowrap hidden sm:block">
        מיון
      </label>
      <select
        value={value.key}
        onChange={(e) => onChange({ ...value, key: e.target.value })}
        className="input h-10 py-0 w-auto min-w-[9rem]"
        aria-label="מיון לפי"
      >
        {options.map((o) => (
          <option key={o.key} value={o.key}>{o.label}</option>
        ))}
      </select>
      <button
        type="button"
        onClick={() => onChange({ ...value, dir: value.dir === 'asc' ? 'desc' : 'asc' })}
        className="btn-secondary btn-sm h-10 px-2.5"
        title={value.dir === 'asc' ? 'עולה — לחצו למיון יורד' : 'יורד — לחצו למיון עולה'}
        aria-label="הפוך כיוון מיון"
      >
        <ArrowsUpDownIcon className="w-4 h-4" />
        <span className="text-xs font-bold">{value.dir === 'asc' ? 'עולה' : 'יורד'}</span>
      </button>
    </div>
  );
}
